import path from "node:path";
import { downloadImage, getFilenameFromUrl, success } from "@iflyrpa/share";

import type { PublishAction } from "./index";

export const rpaAction: PublishAction = async (task, params) => {
    const commonCookies = {
        path: "/",
        secure: true,
        domain: "mp.toutiao.com",
        url: "https://mp.toutiao.com",
        httpOnly: true,
    };

    const page = await task.createPage({
        show: task.debug,
        url: params.url || "https://mp.toutiao.com/profile_v4/weitoutiao/publish",
        cookies: params.cookies?.map((it) => ({ ...it, ...commonCookies })) || [],
    });

    const tmpCachePath = task.getTmpPath();

    // 0. 判断是否登录
    try {
        await page.waitForSelector(".publish-box");
    } catch (error) {
        return { code: 0, message: "登录失效", data: page.url() };
    }

    // 1. 添加正文
    const descInstance = page.locator(".syl-editor .ProseMirror");
    await descInstance.click();
    await descInstance.fill(params.content);

    // 2. 添加图片
    if (params.banners && params.banners?.length > 0) {
        const images = await Promise.all(
            params.banners.map((url) => {
                const fileName = getFilenameFromUrl(url);
                return downloadImage(url, path.join(tmpCachePath, fileName));
            }),
        );

        const fileChooserPromise = page.waitForEvent("filechooser");
        await page.locator(".toolbar .syl-toolbar-tool.weitoutiao-image-plugin").click();
        await page.locator(".byte-drawer.mp-ic-img-drawer button.byte-btn").filter({ hasText: "本地上传" }).click();
        const fileChooser = await fileChooserPromise;
        await fileChooser.setFiles(images);

        await page.locator(".byte-drawer.mp-ic-img-drawer .footer button.byte-btn").filter({ hasText: "确定" }).click();
    }

    // 滚动到底部
    await page.mouse.wheel(0, 500); // 向下滚动 500 像素

    // 3. 添加位置
    if (params.address) {
        const addressFormItem = page
            .locator(".img-form-wrap .form-item-wrap .form-item")
            .filter({ hasText: "添加位置" });
        await addressFormItem.locator(".byte-select").click();
        await addressFormItem.locator(".byte-select-view-search input").fill(params.address);
        const poperInstance = page.locator(".byte-trigger .byte-select-popup .byte-select-option");
        await poperInstance.first().waitFor();
        await poperInstance.first().click();
    }

    // 4. 作品声明
    if (params.declaration) {
        const declarationFormItem = page
            .locator(".img-form-wrap .form-item-wrap .form-item")
            .filter({ hasText: "作品声明" })
            .locator(".source-info-wrap");
        await declarationFormItem.locator(`.byte-checkbox:has(input[value="${params.declaration}"])`).click();
    }

    // 5. 发布
    await page.locator(".footer-wrap button.publish-content").click();

    return success("");
};
